import { render, staticRenderFns } from "./PopupMainMenu.vue?vue&type=template&id=d871e1fe&scoped=true"
import script from "./PopupMainMenu.vue?vue&type=script&lang=js"
export * from "./PopupMainMenu.vue?vue&type=script&lang=js"
import style0 from "./PopupMainMenu.vue?vue&type=style&index=0&id=d871e1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d871e1fe",
  null
  
)

export default component.exports